import React from 'react'
import clsx from 'clsx'
import { TableRow } from '@mui/material'
import styles from './styles.module.scss'

export type AppTableRowProps = {
  disabled?: boolean
  onClick?: () => void
  onMouseDown?: (event: React.MouseEvent) => void
  onMouseEnter?: () => void
  // NOTE: 行 DOM(tr) を親へ渡す ref コールバック。オートスクロール中に各行の
  // getBoundingClientRect を走査して現在行を求めるために使う。
  rowRef?: (el: HTMLTableRowElement | null) => void
} & React.StyledProps &
  React.ChildrenProps

export const AppTableRow: React.StyledFC<AppTableRowProps> = ({
  className,
  children,
  disabled,
  onClick,
  onMouseDown,
  onMouseEnter,
  rowRef,
}: AppTableRowProps) => {
  return (
    <TableRow
      ref={rowRef}
      className={clsx(className, styles.row, disabled && styles.disabled)}
      onClick={() => {
        if (!disabled && onClick) onClick()
      }}
      onMouseDown={(event) => {
        if (!disabled && onMouseDown) onMouseDown(event)
      }}
      onMouseEnter={() => {
        if (!disabled && onMouseEnter) onMouseEnter()
      }}
    >
      {children}
    </TableRow>
  )
}
